import { ActionCopyItem } from '../ActionCopyItem/ActionCopyItem'

type Props<T extends Record<string, unknown>> = {
  getValueToCopy: (row: T) => Promise<string> | string
  displaySeparately?: boolean
}

export const ActionCopyTokenItem = <T extends Record<string, unknown>>({
  getValueToCopy
}: Props<T>) => (
  <ActionCopyItem
    getValueToCopy={getValueToCopy}
    successMessage="Token copied to clipboard"
    errorMessage="Failed to copy token"
    overrideText="Copy Token"
  />
)
